import React from "react";

const BunyanLogo = ({ height = 40, width = 40 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      width={width}
      viewBox="0 0 50 38"
      fill="none"
    >
      <path
        d="M19.9324 17.375L24.9143 20.2693L29.8964 17.375L24.9143 14.4761L19.9324 17.375Z"
        fill="#7EC7BD"
      />
      <path
        d="M14.9458 20.2693V26.0579L19.9325 23.1636L14.9458 20.2693Z"
        fill="#7EC7BD"
      />
      <path
        d="M14.9458 8.6875V14.476L19.9325 17.3752V11.5818L14.9458 8.6875Z"
        fill="#7EC7BD"
      />
      <path
        d="M0 28.9572L4.98198 31.8515L9.96394 28.9572L4.98198 26.0581L0 28.9572Z"
        fill="#7EC7BD"
      />
      <path
        d="M14.9456 37.6444V31.8511L9.96362 34.7454L14.9456 37.6444Z"
        fill="#7EC7BD"
      />
      <path
        d="M9.96362 28.9572L14.9456 26.0581L9.96362 23.1641V28.9572Z"
        fill="#7EC7BD"
      />
      <path
        d="M29.8967 23.164L34.8787 20.2698L29.8967 17.3752V23.164Z"
        fill="#7EC7BD"
      />
      <path
        d="M34.8784 14.4763L39.8604 17.3754V11.582L34.8784 14.4763Z"
        fill="#7EC7BD"
      />
      <path
        d="M49.8244 17.375L44.8424 14.4761L39.8604 17.3753L44.8424 20.2693L49.8244 17.375Z"
        fill="#7EC7BD"
      />
      <path
        d="M44.8425 31.8515L49.8245 28.9572L44.8425 26.0581V31.8515Z"
        fill="#7EC7BD"
      />
      <path
        d="M19.9324 28.9572L24.9143 31.8515L29.8964 28.9572L24.9143 26.0581L19.9324 28.9572Z"
        fill="#7EC7BD"
      />
      <path
        d="M34.8784 2.89429V8.6876L39.8604 5.79332L34.8784 2.89429Z"
        fill="#7EC7BD"
      />
      <path d="M0 17.3752V23.1638L4.98198 20.2695L0 17.3752Z" fill="#7EC7BD" />
      <path
        d="M9.96414 11.582L4.98218 14.4763L9.96414 17.3754V11.582Z"
        fill="#7EC7BD"
      />
      <path
        d="M24.9145 20.2693L14.9458 14.4761V20.2693L19.9325 23.1636L24.9145 20.2693Z"
        fill="#24AE81"
      />
      <path
        d="M19.9325 5.79321L14.9458 8.6875L19.9325 11.5818V5.79321Z"
        fill="#24AE81"
      />
      <path
        d="M24.9146 14.4763L29.8965 17.3754V11.582L24.9146 14.4763Z"
        fill="#24AE81"
      />
      <path
        d="M4.98218 31.8515L9.96414 34.7458L14.9461 31.8515V26.0581L4.98218 31.8515Z"
        fill="#24AE81"
      />
      <path
        d="M29.8967 17.3753L34.8787 20.2693L39.8606 17.375L34.8787 14.4761L29.8967 17.3753Z"
        fill="#24AE81"
      />
      <path
        d="M44.8424 20.2698L39.8604 17.3752V23.164L44.8424 20.2698Z"
        fill="#24AE81"
      />
      <path
        d="M44.8425 14.4763L49.8245 17.3754V11.582L44.8425 14.4763Z"
        fill="#24AE81"
      />
      <path
        d="M49.8245 28.9574V23.1641L44.8425 26.0583L49.8245 28.9574Z"
        fill="#24AE81"
      />
      <path
        d="M29.8965 28.9574V23.1641L24.9146 26.0583L29.8965 28.9574Z"
        fill="#24AE81"
      />
      <path
        d="M19.9324 34.7458L24.9143 31.8516L19.9324 28.9573V34.7458Z"
        fill="#24AE81"
      />
      <path d="M39.8604 0L34.8784 2.89429L39.8604 5.79333V0Z" fill="#24AE81" />
      <path
        d="M4.98198 20.2693L0 23.1636V28.9568L4.98198 26.0579V20.2693Z"
        fill="#24AE81"
      />
      <path
        d="M4.98218 8.6875V14.476L9.96414 11.5818L4.98218 8.6875Z"
        fill="#24AE81"
      />
    </svg>
  );
};

export default BunyanLogo;
